import React from "react";
import filterIcon from "../assets/icons/filter.svg";
import Dropdown from "./Form/Dropdown";

const FilterDropdown = ({
  options = [],
  defaultOption,
  onSelect = () => {},
  filterValue = "",
  className = "",
}) => {
  const fallbackOptions = [
    { _id: "all", name: "All" },
    { _id: "withProfilePic", name: "With Profile Picture" },
    { _id: "withoutProfilePic", name: "Without Profile Picture" },
  ];

  const finalOptions = options.length > 0 ? options : fallbackOptions;

  const selectedOption =
    finalOptions.find((opt) => opt._id === filterValue) || finalOptions[0];

  return (
    <div className={`relative w-[324px] ${className}`}>
      {/* Filter Icon Container */}
      <div className="absolute left-0 top-0 w-[48px] h-full bg-[#272727] flex items-center justify-center rounded-l-[5px] border border-[#808080] border-r-0 z-10">
        <img src={filterIcon} alt="filter" className="w-[24px] h-[24px]" />
      </div>

      {/* Dropdown */}
      <Dropdown
        key={`dropdown-${selectedOption._id}`}
        options={finalOptions}
        defaultOption={selectedOption}
        onSelect={onSelect}
        displayKey="name"
        idKey="_id"
        outerContainerStyle="w-full"
        wrapperClassName="w-full min-w-[324px]"
        buttonClassName="h-[45px] pl-[52px] pr-[12px] bg-[#45444433] border border-[#808080] rounded-[5px] text-left w-full flex items-center justify-between font-['Public_Sans'] text-sm text-[#808080]"
        dropdownClassName="bg-[#2D2D2D] border-[#808080] border"
        optionClassName="py-2 font-['Public_Sans'] text-sm text-[#808080]"
        filterClassName="border-t border-[#505050]"
        isSearchable={false}
        allowClear={false}
      />
    </div>
  );
};

export default FilterDropdown;
